import { useIntl } from "react-intl";
import { Modal } from "@/components/common/modal/Modal";
import styles from "./FormPrivacyModal.module.scss";

type FormPrivacyModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onClose: () => void;
};

export const FormPrivacyModal = ({
  isOpen,
  setIsOpen,
  onClose,
}: FormPrivacyModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onClose={onClose}
      title={intl.formatMessage({ id: "b2bFormPrivacyPolicyTitle" })}
      overrideStyles={{
        modal: styles.modalRoot,
        close: styles.modalClose,
        title: styles.modalTitle,
      }}
    >
      <div className={styles.modalContent}>
        {intl.formatMessage(
          { id: "b2bFormPrivacyPolicyContent" },
          { br: () => <br /> }
        )}
      </div>
    </Modal>
  );
};
